module.exports = __webpack_public_path__ + "static/mobile-click-injection-4f084b47e2e3678d919b715b5bb76c77.gif";